import React from 'react';
import PropTypes from 'prop-types';

import ListItem from 'components/filters/MobileSelect/components/ListItem';
import DefaultControls from 'components/filters/MobileSelect/components/DefaultControls';

const MobileList = ({
	filterList,
	filterOptions,
	onFilterChange,
	onFilterReset,
	resetOneFilter,
	setModalStatus,
	defaultFiltersValues,
	switchFilter
}) => {
	const keys = Object.keys(filterList);

	const applyHandler = () => {
		onFilterChange(filterOptions);
		setModalStatus(false);
	};

	const clearHandler = () => {
		onFilterReset();
	};

	return (
		<>
			{keys.map((key) => (
				<ListItem
					defaultFiltersValues={defaultFiltersValues}
					key={key}
					{...filterList[key]}
					resetOneFilter={resetOneFilter}
					selectedValue={filterOptions[key]}
					switchFilter={switchFilter}
				/>
			))}
			<DefaultControls
				{...{ applyHandler, clearHandler, bottomAligned: true }}
			/>
		</>
	);
};

MobileList.propTypes = {
	filterList: PropTypes.object,
	filterOptions: PropTypes.object,
	defaultFiltersValues: PropTypes.object,
	filters: PropTypes.object,
	onFilterChange: PropTypes.func,
	resetOneFilter: PropTypes.func,
	setModalStatus: PropTypes.func,
	onFilterReset: PropTypes.func,
	onChange: PropTypes.func,
	rubricPath: PropTypes.string,
	switchFilter: PropTypes.func
};

export default MobileList;
